'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ArrowRight01Icon } from '@/components/ui/icon/glyphs';
export function FundingExchangePicker(t0) {
  const $ = _c(16);
  const {
    busy,
    onSelect
  } = t0;
  const t = useTranslations("onramp");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" rounded="" imageClassName="object-contain" src="/assets/onramp/method-coinbase.png" alt="" size="size-10" className="bg-transparent" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("exchange_coinbase");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-body font-medium">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("exchange_transfer_description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="text-caption text-foreground-secondary">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <span className="flex items-center gap-3">{t1}<span className="flex flex-col items-start">{t3}{t5}</span></span>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== busy || $[13] !== onSelect || $[14] !== t6) {
    t7 = <div className="flex flex-col gap-3"><AnimatedButton variant="tertiary" suffix={ArrowRight01Icon} disabled={busy} className="h-auto min-h-16.5 w-full justify-between rounded-control bg-background-tertiary p-3" onClick={onSelect}>{t6}</AnimatedButton></div>;
    $[12] = busy;
    $[13] = onSelect;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}